// extracted by mini-css-extract-plugin
module.exports = {"containerPages":"CantidadDePaginas_containerPages__2fbsx"};